module.exports = __webpack_public_path__ + "static/media/callGray.2c4c9892.png";